module.exports = __webpack_public_path__ + "media/images/svg/clients/8-8fd5d0038546c21265513ac593d760e8.svg";